<!--
 * @Author: zs
 * @Date: 2022-04-13 15:25:50
 * @LastEditTime: 2022-04-13 17:34:36
 * @Description:
 * @FilePath: \smart-community\src\components\global\Hunfold.vue
-->
<template>
  <div class="Hunfold">
    <div class="search" :style="{ width: '100%' }" v-show="!flag">
      <!-- <el-input
        class="w-50 m-2"
        placeholder="输入关键字"
        :suffix-icon="Search"
        :style="{'width':'500px'}"
      /> -->
      <slot name="type" v-if="flag2"></slot>
      <h-button
        type="primary"
        :style="{ 'margin-left': '10px' }"
        @click="refreshTable"
        v-show="flag1"
        >查询</h-button
      >
      <span
        :style="{
          color: '#316afe',
          'line-height': '30px',
          'margin-left': '10px',
          'font-weight': '900',
          cursor: 'pointer',
        }"
        @click="changeFlag"
      >
        {{ flag === true ? "" : "更多" }}
      </span>
    </div>
    <div
      class="divSHow"
      v-show="flag"
      :style="{
        display: 'inline-block',
        display: 'flex',
        'flex-direction': 'row',
        'flex-wrap': 'wrap',
      }"
    >
      <slot></slot>
      <span
        @click="changeFlag"
        :style="{ color: '#316afe', 'line-height': '30px', cursor: 'pointer' }"
        >{{ flag === true ? "收起" : "" }}</span
      >
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, toRefs } from "vue-demi";
import { Search } from "@element-plus/icons-vue";
export default defineComponent({
  name: "HUnfold",
  components: {},
  props: {
    formItme: {
      type: Number,
      default: 4,
    },
  },
  setup(props, { emit }) {
    const state = reactive({
      flag: false,
      flag1: true,
      flag2: true,
    });
    const refData = toRefs(state);
    // 高级搜索展开
    const changeFlag = () => {
      state.flag = !state.flag;
      state.flag1 = !state.flag1;
      state.flag2 = !state.flag2;
    };
    const refreshTable = () => {
      emit("refreshTableEmit");
    };

    return {
      ...refData,
      refreshTable,
      changeFlag,
      Search,
    };
  },
});
</script>

<style lang="scss" scoped>
.Hunfold {
  min-height: 58px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: flex-start;
  .search {
    display: flex;
    align-items: center;
  }
  /deep/.el-form-item {
    // margin-bottom: 0px;
  }
}
</style>